<script setup lang="ts">
import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';

// TODO it's used once now, but same pattern is implemented separately else where
// use this instead
interface IProps {
    title?: string;
    defaultHeight?: number;
    expandButtonId?: string;
    defaultOpen?: boolean;
    moreTitle?: string;
    paddingMobile?: number;
    dataValue: any;
    disabled?: boolean;
    fogies?: boolean;
}
const {
    title = '',
    defaultHeight = 218,
    defaultOpen,
    moreTitle = 'مطالعه بیشتر',
    paddingMobile = 20,
    disabled,
    expandButtonId,
    dataValue,
    fogies,
} = defineProps<IProps>();
const emit = defineEmits<{
    toggle: [];
}>();

const content = ref<HTMLDivElement>();

const isExpanded = ref(defaultOpen);
const maxHeight = ref(100);
const expandable = ref(true);
const boxMaxHeight = computed(() =>
    expandable.value
        ? `${isExpanded.value ? maxHeight.value : defaultHeight}px`
        : null
);
const slots = useSlots();
const iconLeft = computed(() => (isExpanded.value ? faAngleUp : faAngleDown));
const toggle = () => {
    isExpanded.value = !isExpanded.value;
    emit('toggle');
};
const recalculateSize = () =>
    nextTick(() => {
        const contentHeight = content.value?.clientHeight || 0;
        maxHeight.value = contentHeight + 200;
        if (contentHeight) {
            expandable.value = defaultHeight < contentHeight;
        }
    });
watch(
    () => dataValue,
    () => {
        recalculateSize();
    },
    { immediate: true }
);
watch(
    () => disabled,
    val => {
        if (val) {
            expandable.value = false;
        }
    },
    { immediate: true }
);
onMounted(() => recalculateSize());
</script>

<template>
    <div
        class="expandable-card-container"
        :class="{ expanded: isExpanded }"
        :style="{
            'max-height': boxMaxHeight ?? 'unset',
            '--padding-mobile': `${paddingMobile}px`,
        }"
    >
        <slot name="header">
            <h4 v-if="title">
                {{ title }}
            </h4>
        </slot>
        <div ref="content" class="content-container">
            <slot />
        </div>
        <div
            v-if="expandable || slots['extra-button']"
            class="expanding-container"
            :class="{ fogies: expandable && fogies }"
        >
            <mr-button
                :id="expandButtonId"
                class="expand-button"
                :class="{ hidden: !expandable }"
                variant="transparent"
                :left-icon="iconLeft"
                size="medium"
                @click="toggle"
            >
                {{ isExpanded ? 'بستن' : moreTitle }}
            </mr-button>
            <slot v-if="disabled" name="disabled" />
            <slot name="extra-button" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.expandable-card-container {
    position: relative;
    width: 100%;
    @include shadow();
    margin-bottom: 8px;
    transition: all 400ms;
    overflow: hidden;
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    min-height: 80px;
    @include mobile-only {
        padding: var(--padding-mobile, 20px);
    }

    .content-container {
        padding: 0;
    }

    .expanding-container {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        background-color: white;
        &.fogies {
            box-shadow: 10px 10px 15px 30px white;
        }
        @include shadow(0);
        @include mobile-only {
            padding-top: 8px;
        }
        .expand-button {
            &.hidden {
                visibility: hidden;
            }
        }
    }

    &.expanded {
        padding-bottom: 80px;

        .expanding-container {
            @include shadow(0);
        }
    }
}
</style>
